import axios from "axios";
import { getUserToken } from "../../utils/localStoarege";
import { updateConsultationStatusApi, updateMedicineStatusApi, updatePackageStatusApi } from "../../constants/apis/account_apis"

export const accountUpdatePackagesStatus = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(updatePackageStatusApi, data, config);
    return response;
};

export const accountUpdateConsultancyStatus = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(updateConsultationStatusApi, data, config);
    return response;
};

export const accountUpdateMedicineStatus = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(updateMedicineStatusApi, data, config);
    return response;
};
